import ClassSpellPane from './ClassSpellPane';

export default ClassSpellPane;
export { ClassSpellPane };
